import { linearProgressClasses } from '@mui/material';

import colors from 'styles/sass-variables.module.scss';

export const linearProgressOverrides = {
  root: () => ({
    height: '8px',
    borderRadius: '100px',
    backgroundColor: colors.greys_border,
    [`& .${linearProgressClasses.bar}`]: {
      borderRadius: '100px',
      backgroundColor: colors.primary_purple_default,
    },
  }),
};
